<template>
  <header class="navbar sticky-top flex-md-nowrap px-3 py-2 py-md-1">
    <div class="d-none d-md-flex justify-content-between w-100">
      <epi-auto-complete-input
        placeholder="고객명 검색"
        class="text-white my-auto border-0"
        :candidates="fakeNames"
        style="width: 300px"
        :no-border="true"
        v-model="keywordForSearchCustomer"
      />
      <div class="d-flex align-items-center">
        <button
          class="btn btn-link text-decoration-none text-white position-relative"
          @click="notiVisible = !notiVisible"
          ref="notiButton"
        >
          <i class="bi bi-bell"></i> 예약 요청
          <span
            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
          >
            3
          </span>
        </button>

        <div
          class="position-absolute top-100 text-black"
          style="z-index: 1"
          v-if="notiVisible"
          ref="notiBody"
        >
          <div class="card mt-2 p-1 shadow-lg" style="width: 300px">
            <div class="card-body d-flex flex-column gap-3 px-0 pb-1">
              <div class="vstack gap-2">
                <template v-for="i in 3">
                  <div
                    class="d-flex align-items-start border-bottom mb-3 pb-3"
                    :key="i"
                  >
                    <button class="btn">
                      <i class="bi bi-calendar-check"></i>
                    </button>
                    <div class="d-flex flex-column">
                      <p class="flex-grow-1 small mb-1">
                        test client has booked epi care with epi care on
                        10-10-2022 15:00
                      </p>
                      <div class="d-flex justify-content-end gap-2 me-3">
                        <button class="btn btn-sm btn-light">승인</button>
                        <button class="btn btn-sm btn-light">취소</button>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="hstack gap-3 justify-content-end">
                  <button class="btn btn-light">
                    <i class="bi bi-trash"></i>
                    전체 지우기
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button class="btn text-white btn-link text-decoration-none">
          <i class="bi bi-plus"></i> 일정 추가
        </button>
        <button class="btn text-white btn-link text-decoration-none">
          <i class="bi bi-plus"></i> 예약 추가
        </button>
        <button class="btn text-white btn-link text-decoration-none">
          <span class="me-2">내 계정</span>
        </button>
        <div class="dropdown" style="width:60px">
            <button class="btn btn-link text-decoration-none text-black px-0 py-0" data-bs-toggle="dropdown">
                <color-badge color="violet" class="profile rounded-circle" />
            </button>
            <ul class="dropdown-menu" style="min-width: 60px">
                <li>
                    <a href="javascript:0" class="dropdown-item small" @click="Logout()">로그아웃</a>
                </li>
            </ul>
        </div>
      </div>
    </div>
    <div class="d-flex d-md-none w-100 align-items-center">
      <div class="flex-fill">
        <div class="logo-icon-wrapper me-3 d-inline">
          <i class="bi bi-house-fill fs-6 text-white"></i>
        </div>
        <span class="fs-6 fw-normal text-white">에피 마음 센터</span>
      </div>
      <button
        class="navbar-toggler d-md-none collapsed"
        type="button"
        @click="clickToggler"
      >
        <span>
          <i class="bi bi-list text-white"></i>
        </span>
      </button>
    </div>
    
  </header>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "TopMenu",
  data() {
    return {
      show_account : false,
      notiVisible: false,
      fakeNames: [],
      keywordForSearchCustomer: "",
    };
  },
  methods: {
    Logout(){
      this.$store.dispatch('SETLOGOUT').then(
        ()=>{
          window.location.href="/login";
                                }
                            )
    },
    clickToggler() {
      this.$root.$emit(EventName.LeftMenuOffcanvasOpening);
    },
    handleBodyClick(e) {
      if (
        this.notiVisible &&
        !e.path.includes(this.$refs.notiBody) &&
        !e.path.includes(this.$refs.notiButton)
      )
        this.notiVisible = false;
    },
  },
  watch: {
    notiVisible(changed) {
      if (changed === true) {
        document.addEventListener("click", this.handleBodyClick);
      } else {
        document.removeEventListener("click", this.handleBodyClick);
      }
    },
    keywordForSearchCustomer(newVal) {
      alert(newVal);
    },
  },
  mounted() {
    for (let i = 0; i < 100; i++) this.fakeNames.push(Math.random().toString());
  },
};
</script>

<style lang="stylus" scoped>
header
  background-color var(--epi-primary)

  .btn
    --bs-btn-padding-x 0.75rem

select
  background-color var(--epi-primary)

  &:focus
    background-color var(--epi-primary) !important

.profile
  width 40px
  height 40px

#menu a
  &:hover
  &:focus
    color: white !important
</style>
